import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const Botones=()=>{

    let history = useHistory();

    const BotonCrearTipoPlanilla = () =>{

       const onClickBtnCrearTipoPlanilla = () =>{
            history.push("/tipoPlanilla/crear");
        }
        return(
            <Button
            type="primary"
            icon={<PlusOutlined/>}
            onClick={onClickBtnCrearTipoPlanilla}            
            >
                Crear Tipo Planilla
            </Button>
        )

    }
    return(
        <React.Fragment>
            <BotonCrearTipoPlanilla/>
        </React.Fragment>
    )

}
export default Botones;